import { TablePagination, useMediaQuery } from '@mui/material';
import React from 'react';
/**
 * A table pagination component for managing page navigation and row count per page.
 *
 * @param {Props} props - The component props.
 * @param {number} props.total - The total number of rows available.
 * @param {number} props.page - The current page index (zero-based).
 * @param {number} props.rowsPerPage - The number of rows displayed per page.
 * @param {10 | 20 | 50 | 100} [props.initialRowsPerPage] - Optional initial value for rows per page.
 * @param {(page: number, rowsPerPage: number) => void} props.onChange - Callback when page or rowsPerPage changes.
 *
 * @returns {JSX.Element} The rendered pagination component.
 */
export const Pagination = (props) => {
    var _a, _b;
    const [rowsPerPage, setRowsPerPage] = React.useState((_a = props.initialRowsPerPage) !== null && _a !== void 0 ? _a : 50);
    const upSmScreen = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    return (React.createElement(TablePagination, { rowsPerPageOptions: upSmScreen ? [10, 20, 50, 100] : [(_b = props.initialRowsPerPage) !== null && _b !== void 0 ? _b : 50], component: 'div', count: props.total, rowsPerPage: rowsPerPage, page: props.page, onPageChange: (event, page) => props.onChange(page, rowsPerPage), onRowsPerPageChange: (event) => {
            const rowsPerPage = parseInt(event.target.value);
            setRowsPerPage(rowsPerPage);
            props.onChange(0, rowsPerPage);
        }, SelectProps: {
            SelectDisplayProps: { 'data-test': 'rows-per-page-select' },
        }, backIconButtonProps: { 'data-test': 'pagination-back-button' }, nextIconButtonProps: { 'data-test': 'pagination-next-button' } }));
};
